// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { Button, WindmillContext } from "@windmill/react-ui";

// import Error from "components/form/Error";
// import useLoginSubmit from "hooks/useLoginSubmit";
// import LabelArea from "components/form/LabelArea";
// import InputArea from "components/form/InputArea";
// import loginImg from "../assets/img/greenBG.svg";
// import MainLogo from "../assets/img/logo/logo-light.svg";
// import MainLogoDark from "../assets/img/logo/logo-dark.svg";

// const ForgotPassword = () => {
//   const { onSubmit, register, handleSubmit, errors, loading } =
//     useLoginSubmit();

//   const { mode } = useContext(WindmillContext);

//   return (
//     <>
//       <div className="flex justify-center items-center min-h-screen bg-transparent dark:bg-gray-900">
//         <div className="flex items-center relative flex-col md:flex-row loginPageScreen">
//           <main className="forgotPasswordMainContent bg-gray-50 dark:bg-gray-800 flex justify-center p-6">
//             <div className="w-full">
//               <figure>
//                 <img
//                   src={mode === "dark" ? MainLogoDark : MainLogo}
//                   alt="Logo"
//                 />
//               </figure>

//               <h1 className="my-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
//                 Forgot Password
//               </h1>

//               <form onSubmit={handleSubmit(onSubmit)}>
//                 <LabelArea label="Email" />
//                 <InputArea
//                   register={register}
//                   label="Email"
//                   name="email"
//                   type="email"
//                   placeholder="test@example.com"
//                 />
//                 <Error errorName={errors.verifyEmail} />

//                 <Button
//                   disabled={loading}
//                   type="submit"
//                   block
//                   className="my-8 h-12"
//                 >
//                   Recover password
//                 </Button>
//               </form>
//               <p className="mt-4">
//                 <Link
//                   className="text-sm font-medium text-green-500 dark:text-green-400 hover:underline"
//                   to="/login"
//                 >
//                   Back to Login
//                 </Link>
//               </p>
//             </div>
//           </main>

//           <div className="loginScreenImg">
//             <img
//               src={loginImg}
//               className="w-full h-full object-cover"
//               alt="loginImg"
//             />

//             <div className="absolute inset-0 flex justify-center text-gray-200  items-center flex-col px-16 pb-16">
//               <h1 className="text-3xl font-bold">Welcome</h1>
//               <p>Enter you Email and we'll help you reset your password.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ForgotPassword;



import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Button, WindmillContext } from "@windmill/react-ui";

import Error from "components/form/Error";
import useLoginSubmit from "hooks/useLoginSubmit";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import loginImg from "../assets/img/greenBG.svg";
import MainLogo from "../assets/img/logo/logo-light.svg";
import MainLogoDark from "../assets/img/logo/logo-dark.svg";

const ForgotPassword = () => {
  const { onSubmit, register, handleSubmit, errors, loading } =
    useLoginSubmit();

  const { mode } = useContext(WindmillContext);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 px-4 py-6 sm:px-6 lg:px-8">
      <div className="w-full max-w-5xl overflow-hidden rounded-2xl bg-white shadow-xl dark:bg-gray-800">
        <div className="grid min-h-[600px] grid-cols-1 md:grid-cols-2">
          <main className="flex items-center justify-center px-6 py-10 sm:px-10 lg:px-14">
            <div className="w-full max-w-md">
              <div className="mb-8">
                <figure className="mb-8">
                  <img
                    src={mode === "dark" ? MainLogoDark : MainLogo}
                    alt="Logo"
                    className="h-auto w-5/12"
                  />
                </figure>

                <h1 className="mb-3 text-lg font-bold text-gray-800 dark:text-gray-100 sm:text-3xl">
                  Forgot Password?
                </h1>

                <p className="text-sm leading-6 text-gray-500 dark:text-gray-400 sm:text-base">
                  Enter your email address and we'll help you reset your
                  password.
                </p>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-2">
                  <LabelArea label="Email" />

                  <InputArea
                    register={register}
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="Enter your email address"
                  />

                  <Error errorName={errors.verifyEmail} />
                </div>

                <Button
                  disabled={loading}
                  type="submit"
                  block
                  className="mt-6 h-12 rounded-lg text-sm font-semibold"
                >
                  {loading ? "Sending..." : "Recover Password"}
                </Button>
              </form>

              <div className="mt-6 text-center">
                <Link
                  className="text-sm font-medium text-green-600 transition-colors hover:text-green-700 hover:underline dark:text-green-400 dark:hover:text-green-300"
                  to="/login"
                >
                  Back to Login
                </Link>
              </div>
            </div>
          </main>

          <div className="relative hidden overflow-hidden md:block">
            <img
              src={loginImg}
              className="absolute inset-0 h-full w-full object-cover"
              alt="Forgot password"
            />

            <div className="absolute inset-0 bg-black/20" />

            <div className="absolute inset-0 flex flex-col items-center justify-center px-8 text-center text-white lg:px-14">
              <div className="max-w-md">
                <h2 className="mb-4 text-3xl font-bold lg:text-4xl">
                  Welcome Back
                </h2>

                <p className="text-sm leading-7 text-gray-100 lg:text-base">
                  Don't worry if you've forgotten your password. Enter your
                  registered email address and we'll help you regain access to
                  your account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

